<div (click)="goToMainSite()" class="new-logo-container"></div>

<div class="verification-required-pane">
    <div class="letter-img"></div>
    <div class="verification-required-pane-title header-font centered-txt b1Color" i18n>
        {{ 'VERIFICATION_REQUIRED_CHECK_INBOX' | translate }}
    </div>
    <div class="verification-required-pane-content cnt-column-centered">
        <label class="p1Font" i18n>{{ 'YOU_NEED_TO_VERIFY' | translate }}</label>
        <label class="p1Font" i18n>{{ 'SENT_A_VERIFICATION_MAIL' | translate }}.</label>
        <div class="h2Font centered-txt b1Color verification-required-pane-content-email" i18n>{{ 'SENT_TO' | translate }} {{email}}</div>
    </div>
</div>